import React, { useContext } from 'react';

import { StaticContext } from '@sm/webassets';
import { defineMessages } from '@sm/intl';
import { Typography } from '@sm/wds-react';

import SearchBox from '../../../../components/SearchBox';
import './jumbo-header.scss';

export const COPY = defineMessages({
  JUMBO_TAGLINE: {
    id: 'Home.JumboHeader.Tagline',
    defaultMessage: "We're better together",
    description: '[Type: Header][Vis.: high] - The main tagline for the home page',
  },
  JUMBO_SUBTITLE: {
    id: 'Home.JumboHeader.Subtitle',
    defaultMessage: 'Integrate with over 100+ SurveyMonkey apps and plug-ins to get more done',
    description: "[Type: Header][Vis.: high] - A small description of what's available on the app directory page",
  },
});

const JumboHeader = () => {
  const { user, HEADER_EXP: { isModernTreatment = false } = {} } = useContext(StaticContext);
  const shouldShowNewHeader = user.isAuthenticated && isModernTreatment;
  return (
    <div
      data-testid="JumboHeader__AppsDirectory"
      className={`${
        shouldShowNewHeader ? 'sm-jumbo-header--modern' : ''
      } sm-jumbo-header wds-flex wds-flex--y wds-flex--y-center wds-p-l-5 wds-p-r-5`}
    >
      <Typography variant="hero1" component="h1" color="light" className="sm-jumbo-header__title">
        {COPY.JUMBO_TAGLINE.defaultMessage}
      </Typography>
      <Typography variant="cardTitle" component="div" color="light" className="sm-jumbo-header__subtitle">
        {COPY.JUMBO_SUBTITLE.defaultMessage}
      </Typography>
      <div className="sm-jumbo-header__search-box-wrapper wds-m-t-4">
        <SearchBox location="app directory homepage" />
      </div>
    </div>
  );
};

export default JumboHeader;
